import { __awaiter } from "tslib";
import { createElement, Fragment, useEffect, useRef } from 'rax';
import Icon from '../icon';
import View from '../view';
import classNames from 'classnames';
import { getElementBoundingClientRect, isAndroid, isIOS } from '../utils';
import { useDebounce } from '../utils/hooks';
function computeValue({ x, count, width, allowHalf, }) {
    const stepWidth = width / count;
    const xStep = Math.floor(x / stepWidth);
    const remainder = x % stepWidth;
    if (!allowHalf) {
        return remainder ? xStep + 1 : xStep;
    }
    return xStep + (remainder / stepWidth >= 0.5 ? 1 : 0.5);
}
export function getDefaultItemRender({ iconType, size, classnames, }) {
    return function defaultItemRender({ key, value, isActive, isHalfActive }) {
        return (<Fragment>
        <Icon name={iconType} size={size} className={isActive ? classnames.activeIcon : classnames.icon}/>
        {!!isHalfActive && (<View key={`${key}-overlay`} className={classNames(classnames.iconWrapper, `${classnames.iconWrapper}--overlay`)}>
            <Icon name={iconType} size={size} className={classnames.activeIcon} style={{
                    width: `${100 * (value - key)}%`,
                }}/>
          </View>)}
      </Fragment>);
    };
}
export function useTouchChangeEventProps({ id, value, onChange, allowHalf, count, disabled, }) {
    const containerRectRef = useRef();
    const debouncedGetContainerRect = useDebounce(() => __awaiter(this, void 0, void 0, function* () {
        const rect = yield getElementBoundingClientRect(id);
        containerRectRef.current = { left: rect.left, width: rect.width };
    }), 16);
    useEffect(() => {
        debouncedGetContainerRect();
        return () => {
            debouncedGetContainerRect.cancel();
        };
    });
    const handleChange = useDebounce((x, width) => {
        const newValue = computeValue({
            x,
            allowHalf,
            width,
            count,
        });
        if (value !== newValue) {
            onChange(newValue);
        }
    });
    useEffect(() => {
        return () => {
            handleChange.cancel();
        };
    }, [handleChange]);
    const handleClick = (e) => {
        const hoverX = e.pageX;
        const rect = containerRectRef.current;
        if (rect) {
            handleChange(hoverX - rect.left, rect.width);
        }
    };
    const handleTouch = (e) => {
        var _a, _b;
        const touchX = (_b = (_a = e.touches) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.pageX;
        const rect = containerRectRef.current;
        if (rect && typeof touchX === 'number') {
            handleChange(touchX - rect.left, rect.width);
        }
    };
    if (disabled) {
        return {};
    }
    if (isIOS || isAndroid) {
        return {
            onTouchStart: (e) => {
                e.preventDefault();
                handleTouch(e);
            },
            onTouchMove: handleTouch,
            onTouchEnd: handleTouch,
        };
    }
    return {
        onClick: handleClick,
    };
}
